import React from 'react';
import css from './index.module.css';
import { Link } from 'gatsby';

interface ArticleReferencesProps {
  previous: any | null;
  next: any | null;
  pathPrefix: string;
}

export const ArticleReferences = (props: ArticleReferencesProps) => (
  <ul className={css.links}>
    <li>
      {props.previous && (
        <Link
          className={css.link}
          to={`/${props.pathPrefix}${props.previous.fields.slug}`}
          rel="prev"
        >
          ← {props.previous.frontmatter.title}
        </Link>
      )}
    </li>
    <li>
      {props.next && (
        <Link
          className={css.link}
          to={`/${props.pathPrefix}${props.next.fields.slug}`}
          rel="next"
        >
          {props.next.frontmatter.title} →
        </Link>
      )}
    </li>
  </ul>
);
